import addClassTemplate from './addClassPopup.html';

export default function ClassController($location, $scope, $state, localStorageService, ClassRoomService, $mdDialog) {
  var self = this;

	$scope.sortType     = 'classRoomName'; // set the default sort type
  $scope.sortReverse  = false;  // set the default sort order
  $scope.searchClass   = '';     // set the default search/filter term
  
  // create the list of Class Rooms(dummy)
  //localStorageService.set('classObj', $scope.classObj);
  self.allClassRooms = localStorageService.get('classrooms');
  self.allSubjects = localStorageService.get('subjects');

  self.searchClicked = false;

  self.clickOnSearch = function(){
    self.searchClicked = !self.searchClicked;
  };

  self.clickOnClassName = function(classObj){
    $state.go('olr.mainfe.indvclass', {classRoomName: classObj.classRoomName, subName:classObj.subjectName, cId: classObj.classRoomId });
  };

  $scope.selected = [];

  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.toggleAll = function (){
    if ($scope.selected.length === self.allClassRooms.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = self.allClassRooms.slice(0);
    }
  };

  $scope.isChecked = function() {
    return $scope.selected.length === self.allClassRooms.length;
  };

  self.addClassRoom = function(){
    $mdDialog.show({
      template: addClassTemplate,
      controller: AddClassController
    }).finally(function(){
      //Do Nothing Here
    });
  };

  var AddClassController = function($scope, $mdDialog){
    $scope.classObj = {classRoomName: '', subject: ''};

    $scope.querySearch   = querySearch;
    $scope.selectedSubjectChange = selectedSubjectChange;
    $scope.searchTextChange   = searchTextChange;

    $scope.newSubject = function(subjectName) {
      $mdDialog.hide();
      self.addSubject({'subjectName':subjectName, 'subjectDesc': ''});
    };

    function querySearch (query) {
      var results = query ? self.allSubjects.filter( createFilterFor(query) ) : self.allSubjects,
        deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } 
      else {
        return results;
      }
    }

    function searchTextChange(text) {
      $scope.displayAutoCompleteError = false;
    }

    function selectedSubjectChange(item) {
      if(item){
        $scope.selectedSubject = item;
      }
      else{
        
      }
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(classObj) {
        return (classObj.subjectName.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {

      $scope.displayAutoCompleteError = $scope.selectedSubject ? false : true;
      if($scope.addClassForm.$invalid || $scope.displayAutoCompleteError){
        angular.forEach($scope.addClassForm, function(val, key) {
          if (!key.match(/\$/)) {
            val.$dirty = true;
            val.$touched = true;
          }
        });
        return;
      }

      let tempReq = {
        'classRoomName' : $scope.classObj.classRoomName, 
        'subjectName': $scope.selectedSubject.subjectName, 
        'subjectId': $scope.selectedSubject.subjectId
      };
      ClassRoomService.saveClassRoom(tempReq).then(function(resp) {
        tempReq.classRoomId = resp.data.classRoomId;
        
        if(resp.data.classRoomId && !resp.data.classRoomExist){
          self.allClassRooms.push(tempReq);
          localStorageService.set('classRooms', self.allClassRooms);
        }


        if(resp.data.classRoomExist){
          $scope.showClassExistError = true;
        }
        else{
          self.allClassRooms = localStorageService.get('classRooms') || [];
          if(self.allClassRooms.length > 0){
            self.showAddClass = false;
          }
          $mdDialog.hide();
        }
        //$state.go('olr.mainfe.contact');
      });
      //self.studentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
    };
  };
}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-class/ClassController.js
 **/